export const REVENUE_REPORT_APPROVED = "REVENUE_REPORT_APPROVED";
export const REVENUE_REPORT_SNOOZED = "REVENUE_REPORT_SNOOZED";
